import moment from 'moment';
import { useSelector } from 'react-redux';
import { TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import 'react-accessible-accordion/dist/fancy-example.css';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Accordion, AccordionItem, } from 'react-accessible-accordion';

import ActivityCard from './ActivityCard/index.js';
import DataHighlights from '../../components/DataHighlights';

const Overview = (props) => {
    let { currentWorkspace } = useSelector(state => state['Settings']);
    let { singleActivityId, singleId, singlePageData, dropdowns, setDropdowns, toggleDropdownAction, searchText, objectType } = props;

    let [activities, setActivities] = useState([]);
    let [isExpandAll, setIsExpandAll] = useState(false);
    let [preExpandedItems, setPreExpandedItems] = useState(['a-0']);

    useEffect(() => {
        if (singlePageData?.['activitiesGrouped'] && singlePageData?.['activitiesGrouped'].length > 0) {
            // Flatten all activities from groups into a single array
            let allActivities = [];
            singlePageData['activitiesGrouped'].forEach(group => {
                if (group?.['activities']) {
                    allActivities = allActivities.concat(group['activities'].map(activity => ({
                        ...activity,
                        group: group // Attach group info to each activity
                    })));
                }
            });
            setActivities(allActivities);
        } else if (singlePageData?.['activities'] && singlePageData?.['activities'].length > 0) {
            // Fallback to regular activities if activitiesGrouped is not available
            setActivities(singlePageData['activities']);
        }
    }, [singlePageData]);

    useEffect(() => {
        if (isExpandAll) setPreExpandedItems(activities?.map((activity, index) => `a-${index}`));
        else setPreExpandedItems([]);
    }, [isExpandAll]);


    return (
        <div className='tab-detail-box'>
            {!singleActivityId && (
                <DataHighlights 
                    objectType={objectType} 
                    data={singlePageData} 
                />
            )}
            <div className="highlights-bottom-accordian">
                <div className="header-area">
                    <div className="header-search-area">
                        <h4>Recent activities</h4>
                        <div className='searchbox'>
                        </div>
                        {activities && activities.length > 0 && <>
                            <Dropdown isOpen={dropdowns['FilterActivity'] || false} toggle={() => toggleDropdownAction('FilterActivity')} >
                                <DropdownToggle caret>
                                    Filter activity {activities?.length < 3 ? activities?.length : '3'}/{activities?.length}
                                    <i className="icon">
                                        <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                                            <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
                                        </svg>
                                    </i>
                                </DropdownToggle>
                                <DropdownMenu><DropdownItem onClick={() => setIsExpandAll(!isExpandAll)}>{isExpandAll ? 'Expand' : 'Collapse'} All</DropdownItem></DropdownMenu>
                            </Dropdown>
                        </>}
                    </div>
                </div>
                <div className="main-side-accordian overview-tab">
                    {(() => {
                        let filteredActivities = activities.filter((activity) => !searchText || activity?.['title']?.toLowerCase().includes(searchText.toLowerCase()) || activity?.['description']?.toLowerCase().includes(searchText.toLowerCase()));
                        if (singleActivityId) filteredActivities = filteredActivities.filter((activity) => activity['_id'] == singleActivityId);
                        return (filteredActivities && filteredActivities.length > 0) ? (
                            <Accordion key={isExpandAll ? 'expanded' : 'collapsed'} allowMultipleExpanded={true} allowZeroExpanded={true} preExpanded={preExpandedItems}>
                                {filteredActivities.slice(0, 3).map((activity, index) => (
                                    <ActivityCard
                                        singlePageData={singlePageData}
                                        activity={activity}
                                        group={activity.group}
                                        index={index}
                                        key={`a-${activity['type']}-${index}`}
                                    />
                                ))}
                            </Accordion>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#89868D' }} className='notfound-area'>
                                <div className='img-box'>
                                    <img alt="..." src={require('../../static/img/not-found.png')} />
                                </div>
                                <p>No activities found</p>
                            </div>
                        );
                    })()}
                </div>
            </div>
        </div>
    );
};

export default Overview;